import InfoIconContainer from './InfoIconContainer';
import InfoIconUI from './InfoIconUI';

const InfoIcon = {
    Container: InfoIconContainer,
    UI: InfoIconUI
};

export default InfoIcon;
